// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/suggested_reviewers.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/suggested_reviewers.proto.
 */
export const file_pull_requests_v1_suggested_reviewers: GenFile = /*@__PURE__*/
  fileDesc("CipwdWxsX3JlcXVlc3RzL3YxL3N1Z2dlc3RlZF9yZXZpZXdlcnMucHJvdG8SF2dpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxImUKGlN1Z2dlc3RlZFJldmlld2Vyc1Jlc3BvbnNlEkcKE3N1Z2dlc3RlZF9yZXZpZXdlcnMYASADKAsyKi5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5TdWdnZXN0ZWRSZXZpZXdlciJdChFTdWdnZXN0ZWRSZXZpZXdlchIzCghyZXZpZXdlchgBIAEoCzIhLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlJldmlld2VyEhMKC2Rlc2NyaXB0aW9uGAIgASgJIoIBCghSZXZpZXdlchIKCgJpZBgBIAEoAxIVCg1kaXNwbGF5X2xvZ2luGAIgASgJEgwKBG5hbWUYAyABKAkSEgoKYXZhdGFyX3VybBgEIAEoCRIVCg1yZXZpZXdlcl90eXBlGAUgASgJEhoKEm9yZ2FuaXphdGlvbl9sb2dpbhgGIAEoCWIGcHJvdG8z");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/suggested_reviewers
 *
 * Defined by PullRequests::PageData::ReviewersController#suggested_reviewers.
 *
 * @generated from message github.pull_requests.v1.SuggestedReviewersResponse
 */
export type SuggestedReviewersResponse = Message<"github.pull_requests.v1.SuggestedReviewersResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.SuggestedReviewer suggested_reviewers = 1;
   */
  suggestedReviewers: SuggestedReviewer[];
};

/**
 * Describes the message github.pull_requests.v1.SuggestedReviewersResponse.
 * Use `create(SuggestedReviewersResponseSchema)` to create a new message.
 */
export const SuggestedReviewersResponseSchema: GenMessage<SuggestedReviewersResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_suggested_reviewers, 0);

/**
 * @generated from message github.pull_requests.v1.SuggestedReviewer
 */
export type SuggestedReviewer = Message<"github.pull_requests.v1.SuggestedReviewer"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * Human-readable reason the reviewer is suggested (e.g. "Recently edited
   * these files").
   *
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message github.pull_requests.v1.SuggestedReviewer.
 * Use `create(SuggestedReviewerSchema)` to create a new message.
 */
export const SuggestedReviewerSchema: GenMessage<SuggestedReviewer> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_suggested_reviewers, 1);

/**
 * @generated from message github.pull_requests.v1.Reviewer
 */
export type Reviewer = Message<"github.pull_requests.v1.Reviewer"> & {
  /**
   * Reviewer id. int64 (serialized as a JSON string) since ids can exceed the
   * int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * Display name; absent when the value is null or empty.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * Either "User" or "Team". Suggested reviewers are always users today.
   *
   * @generated from field: string reviewer_type = 5;
   */
  reviewerType: string;

  /**
   * Organization login; absent for users or when the value is null.
   *
   * @generated from field: string organization_login = 6;
   */
  organizationLogin: string;
};

/**
 * Describes the message github.pull_requests.v1.Reviewer.
 * Use `create(ReviewerSchema)` to create a new message.
 */
export const ReviewerSchema: GenMessage<Reviewer> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_suggested_reviewers, 2);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(SuggestedReviewersResponseSchema, "b61b534517df")
registerSchemaHash(SuggestedReviewerSchema, "af79a4034fae")
registerSchemaHash(ReviewerSchema, "b2bf46d549ca")
